var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegalrep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-legalrep",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multiple-11",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FB9A02",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,11 C4.791,11 3,9.209 3,7 C3,4.791 4.791,3 7,3 C9.209,3 11,4.791 11,7 C11,9.209 9.209,11 7,11 Z",
    id: "Stroke-1",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,41 L4,41 L3,30 L0,29 L0,20 C0,17.791 1.791,16 4,16 L10,16 C11.454,16 12.727,16.777 13.427,17.937",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,11 C39.209,11 41,9.209 41,7 C41,4.791 39.209,3 37,3 C34.791,3 33,4.791 33,7 C33,9.209 34.791,11 37,11 Z",
    id: "Stroke-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,41 L40,41 L41,30 L44,29 L44,20 C44,17.791 42.209,16 40,16 L34,16 C32.546,16 31.273,16.777 30.573,17.937",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,12 C18.686,12 16,9.314 16,6 C16,2.686 18.686,0 22,0 C25.314,0 28,2.686 28,6 C28,9.314 25.314,12 22,12 Z",
    id: "Stroke-9",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,44 L17,44 L16,32 L12,31 L12,21 C12,18.791 13.791,17 16,17 L28,17 C30.209,17 32,18.791 32,21 L32,31 L28,32 L27,44 Z",
    id: "Stroke-11",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalrep);
export default __webpack_public_path__ + "static/media/legalrep.cbea624079a2399e150ce3c9d663559c.svg";
export { ForwardRef as ReactComponent };